/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Planticketfee2Inputs */

const en_planticketfee2 = /** @type {(inputs: Planticketfee2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ticket fee ${i?.fee}`)
};

const de_planticketfee2 = /** @type {(inputs: Planticketfee2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ticketgebühr ${i?.fee}`)
};

/**
* | output |
* | --- |
* | "Ticket fee {fee}" |
*
* @param {Planticketfee2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planticketfee2 = /** @type {((inputs: Planticketfee2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planticketfee2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planticketfee2(inputs)
	return de_planticketfee2(inputs)
});
export { planticketfee2 as "planTicketFee" }